import { FC, MouseEvent, ReactElement } from 'react';
import { IRegistrationProps } from './IRegistrationProps';
import PageTemplate from '../PageTemplate';
import commonStyles from '../styles';
import { createStyles } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core';
import { resendApproveEmail } from '../../../redux/actions/signUpActions';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const RegistrationEmail = ({ handleNext, nextButtonContent }: IRegistrationProps): ReactElement => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { link } = makeStyles((theme) => createStyles(commonStyles(theme)))();
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    dispatch(resendApproveEmail());
  };

  const FinishHint: FC = () => (
    <>
      {t('auth.resend.mail')}{' '}
      <a className={link} href="/" onClick={handleClick}>
        {t('auth.resend.mail.again')}
      </a>
    </>
  );

  return (
    <PageTemplate
      title={t('auth.register.confirmation')}
      description={t('auth.check.your.mail')}
      hint={<FinishHint />}
      submitButtonContent={nextButtonContent}
      submit={handleNext}
    />
  );
};

export default RegistrationEmail;
